//// Application Configuration

//// Application Packages
import React from 'react'

//// Application Slices

//// Application Components
import LoadingComponent from '../../components/simple-components/loading-component'

//// Carbon Components

//// Carbon Icons

//// Static Constants

//////////////// Component
const LoadingPage = () => {
    //////// Hooks

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Method

    //////// Functional Methods

    // Functional Method

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return

    return (
        <>
            <LoadingComponent />
        </>
    )
}

export default LoadingPage
